import { gql } from '@apollo/client';

export const getVerificationById = gql`
  query verificationById($verifyId: Float!) {
    verificationById(id: $verifyId) {
      VerifyId
      Status
      AssetNumber
      BarCodeNumber
      VerifyDate
      UserId
      userDepartment {
        id
        Name
        Abbreviation
      }
      Type
      itemDepartment {
        id
        Name
        Abbreviation
      }
      latitude
      longitude
    }
  }
`;

export const getCommentsByBarcode = gql`
  query readCommentsByBarcode($barCode: String!) {
    readCommentsByBarcode(barCode: $barCode) {
      lastUpdatedBy
      createdOn
      comment
    }
  }
`;

export const getCommentsByVerifyId = (verifyId: number) => {
  return gql`
    {
      readCommentsByVerifyId(verifyId: ${verifyId}) {
        lastUpdatedBy
        createdOn
        comment
      }
    }
  `;
};

export const getComments = gql`
  query readComments($verifyId: Float!, $barcode: String) {
    readComments(verifyId: $verifyId, barcode: $barcode) {
      lastUpdatedBy
      createdOn
      comment
    }
  }
`;

// For creating a new verification
export const GET_ASSETS_VIEW_ITEM_BY_ID = (AssetsViewId) => {
  return gql`

    {
      assetsViewById(id:${AssetsViewId}) {
        AssetID
        source
        BarCode
        Description
        Description2
        Description3
        AssetNumber
        SerialNumber
        DepartmentID
        Owner
        Status
        Year
      }
    }`;
};

export const createVerificationMutation = gql`
  mutation createVerification(
    $id: Int
    $status: String!
    $barCode: String
    $userId: String!
    $userDepartment: String!
    $type: String!
    $itemDepartment: String
    $latitude: Float
    $longitude: Float
    $verifyDate: DateTime
    $assetNumber: String
  ) {
    createVerification(
      verification: {
        VerifyId: $id
        Status: $status
        BarCodeNumber: $barCode
        UserId: $userId
        userDepartment: { Name: $userDepartment }
        Type: $type
        itemDepartment: { Name: $itemDepartment }
        AssetNumber: $assetNumber
        latitude: $latitude
        longitude: $longitude
        VerifyDate: $verifyDate
      }
    ) {
      VerifyId
    }
  }
`;

export const updateVerificationMutation = gql`
  mutation updateVerification(
    $id: Int
    $status: String!
    $barCode: String!
    $userId: String!
    $userDepartment: String!
    $type: String!
    $itemDepartment: String
    $latitude: Float
    $longitude: Float
    $verifyDate: DateTime
    $transferTo: String
  ) {
    updateVerification(
      verification: {
        VerifyId: $id
        Status: $status
        BarCodeNumber: $barCode
        UserId: $userId
        userDepartment: { Name: $userDepartment }
        Type: $type
        itemDepartment: { Name: $itemDepartment }
        latitude: $latitude
        longitude: $longitude
        VerifyDate: $verifyDate
        transferTo: $transferTo
      }
    ) {
      VerifyId
    }
  }
`;

export const createCommentMutation = gql`
  mutation createComment(
    $barcode: String
    $comment: String
    $createdBy: String
    $createdOn: DateTime
    $lastUpdatedBy: String
    $updatedOn: DateTime
    $verifyId: Float!
    $entryType: String
    $requestId: Float
  ) {
    createComment(
      comment: {
        barcode: $barcode
        comment: $comment
        createdBy: $createdBy
        createdOn: $createdOn
        lastUpdatedBy: $lastUpdatedBy
        updatedOn: $updatedOn
        entryType: $entryType
        requestId: $requestId
      }
      verifyId: $verifyId
    ) {
      id
    }
  }
`;

export const readAllDepartments = gql`
  {
    readAllDepartments: readDepartments {
      id
      Name
      Abbreviation
    }
  }
`;

export const readAllStatuses = gql`
  {
    readAllStatuses {
      id
      statusName
    }
  }
`;

export const createEOneFromVerficationMutation = gql`
  mutation createEOneFromVerification($asset: VerificationSlimInput!) {
    createEOneFromVerfication(verificationAsset: $asset) {
      id
    }
  }
`;

export const getEquipCodes = gql`
  {
    readAllEquipmentCodes {
      Description
      EquipCodeId
    }
  }
`;

export const readOneFixedAsset = gql`
  query ($barcode: String!) {
    readOneFixedAsset(barCode: $barcode) {
      barCode
      department
      physicalOwner
      equipmentStatus
    }
  }
`;
